import { PDFDocument } from "pdf-lib";

export const createPdf = () => {
    return PDFDocument.create();
};

export const loadFromUrl = async (url: string) => {
    return fetch(url).then(res => res.arrayBuffer());
}

export const loadPdf = async (existingPdf: ArrayBuffer) => {
    // const existingPdf = await loadFromUrl(url);
    return PDFDocument.load(existingPdf);
};

export const copyPages = (targetPdf: PDFDocument, srcPdf: PDFDocument, pagesToUse: number[]) => {
    return targetPdf.copyPages(srcPdf, pagesToUse);
}

export const savePdf = (targetPdf: PDFDocument) => {
    return targetPdf.save();
}

export const createPdfFromUrl = async (existingPdf: ArrayBuffer, pagesToUse?: number[]) => {
    const pdfNewDoc = await createPdf();
    const pdfDoc = await loadPdf(existingPdf);
    if (pagesToUse?.length) {
        // pdf-lib pages starts from zero 0, so we will update the page number
        let updatedPages = pagesToUse.map(page => page - 1);
        const pages = await copyPages(pdfNewDoc, pdfDoc, updatedPages);
        pages.forEach(page => pdfNewDoc.addPage(page));
    }
    
    return savePdf(pdfNewDoc);
}

export const downloadPdf = (pdf: Uint8Array, fileName: string = 'Document') => {
    const url = window.URL.createObjectURL(new Blob([pdf.buffer]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
}